import { Locale } from '@stepstone-platform/platform-apis';
import { useEffect, useState } from 'react';

export const useLanguageSwitch = (currentLocale) => {
  const [updatedLocale, setUpdatedLocale] = useState<Locale | null>(null);
  useEffect(() => {
    document.addEventListener('LANGUAGE_SWITCHED_RLA_INTEGRATION', (e) => {
      setUpdatedLocale(
        (e.detail.languageId + currentLocale.slice(2)) as Locale,
      );
    });
  }, []);

  return { updatedLocale };
};
